/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.compliance.payrules
 * @name TimeCompliancePayRulesViewCtrl
 */
angular.module('mercury.modules.time.compliance.payrules')
.controller('TimeCompliancePayRulesViewCtrl', ["$filter", "$state", "$scope", "title", "$stateParams", "PayRules", "helperUtils", function($filter, $state, $scope, title, $stateParams, PayRules, helperUtils) {
  title.set('View Pay Adjustment Package');

  $scope.errorMessage = null;
  $scope.selectedPackage = {};
  $scope.schedulePopoverTitle = 'Full Schedule';

  $scope.ruleTypes = [
    {type: 'Add', label: 'Dollar amount above normal rate'},
    {type: 'Subtract', label: 'Dollar amount below normal rate'},
    {type: 'Equals', label: 'Fixed dollar amount'},
    {type: 'Multiple', label: 'Percentage of normal rate'}
  ];

  // find the next upcoming schedule to display
  getNextSchedule = function(scheduleList) {
    var now = helperUtils.now();
    var nextSchedule = null;

    // schedules are ordered by datestampStart in the backend so the first entry that is greater than the current time is the next upcoming start time
    nextSchedule = scheduleList.find(function(schedule) {
      var start = new Date(schedule.datestampStart).getTime();
      return start >= now;
    });

    // if we do not find any but some old dates exist then return the first entry
    if (!nextSchedule && scheduleList.length > 0) {
      nextSchedule = scheduleList[0];
    }
    return nextSchedule;
  };

  $scope.loading = PayRules.getById($stateParams.id);
  $scope.loading.then(function(p) {
    angular.forEach(p.rules, function(rule) {
      rule.nextSchedule = getNextSchedule(rule.schedule);
    });
    $scope.selectedPackage = p;
  }, function() {
    $scope.errorMessage = 'Failed to find your selected package';
  });

  $scope.goBack = function() {
    window.history.back();
  };

}]);
